// Services.
import { DictStorageService } from '../dict-storage/dict-storage.service';
import { LoggerService, LogLevel } from '../logger/logger.service';
import { Logger } from '../../classes/logger';
import * as i0 from "@angular/core";
import * as i1 from "../dict-storage/dict-storage.service";
import * as i2 from "../logger/logger.service";
export class StorageService {
    constructor(dictStorage, loggerSrvc) {
        this.dictStorage = dictStorage;
        this.storage = {};
        this.loading = true;
        this.logger = new Logger(loggerSrvc, this.constructor.name);
        this.logger.setLogLevel(LogLevel.WARNING);
    }
    putLang(lang) {
        localStorage.setItem('lang', JSON.stringify(lang));
    }
    getLang() {
        if (localStorage.getItem('lang') == null) {
            this.putLang({});
        }
        return JSON.parse(localStorage.getItem('lang'));
    }
    setLangs(lang) {
        this.dictStorage.put('langs', lang);
    }
    getLangs() {
        return this.dictStorage.get('langs');
    }
    // Article methods.
    ///////////////////
    putArticle(article) {
        this.logger.log(`Storing Article with id "${article.id}"`, article);
        this.dictStorage.put(this.articleKeyFromId(article.id), article);
    }
    getArticle(articleId) {
        let article = this.dictStorage.get(this.articleKeyFromId(articleId));
        this.logger.log(`Recovering Article with id "${this.articleKeyFromId(articleId)}"`, article);
        return article;
    }
    articleKeyFromId(id) {
        return 'art-' + id + 'lang-' + this.getLang().LangID;
    }
    // IndexItem methods.
    /////////////////////
    putIndexItem(indexItem) {
        this.logger.log(`Storing IndexItem with id "${indexItem.id}"`, indexItem);
        this.dictStorage.put(this.indexItemKeyFromId(indexItem.id), indexItem);
    }
    getIndexItem(indexItemId) {
        let indexItem = this.dictStorage.get(this.indexItemKeyFromId(indexItemId));
        this.logger.log(`Recovering IndexItem with id "${indexItemId}"`, indexItem);
        return indexItem;
    }
    indexItemKeyFromId(id) {
        return 'idx-' + id + 'lang-' + this.getLang().LangID;
    }
    // Image methods.
    /////////////////
    putImage(image) {
        this.logger.log(`Storing RBImage with id "${image.id}"`, image);
        this.dictStorage.put(this.imageKeyFromId(image.id), image);
    }
    getImage(imageId) {
        let image = this.dictStorage.get(this.imageKeyFromId(imageId));
        this.logger.log(`Recovering RBImage with id "${imageId}"`, image);
        return image;
    }
    imageKeyFromId(id) {
        return 'img-' + id + 'lang-' + this.getLang().LangID;
    }
    // Flying page methods.
    ///////////////////
    putFlyingPage(flyingPage) {
        this.logger.log(`Storing FlyingPage with id "${flyingPage.id}"`, flyingPage);
        this.dictStorage.put(this.flyingPageKeyFromId(flyingPage.id), flyingPage);
    }
    getFlyingPage(flyingPageId) {
        let flyingPage = this.dictStorage.get(this.flyingPageKeyFromId(flyingPageId));
        this.logger.log(`Recovering FlyingPage with id "${flyingPageId}"`, flyingPage);
        return flyingPage;
    }
    flyingPageKeyFromId(id) {
        return 'flyp-' + id + 'lang-' + this.getLang().LangID;
    }
}
StorageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function StorageService_Factory() { return new StorageService(i0.ɵɵinject(i1.DictStorageService), i0.ɵɵinject(i2.LoggerService)); }, token: StorageService, providedIn: "root" });
